var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { useEffect } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '../../store';
import { updateTheme } from '../../store/slices/roomSettingsSlice';
const themeSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.theme);
$RefreshReg$(_react_refresh_temp_1, "themeSelector$createSelector");
const useThemeSettings = () => {
    _react_refresh_temp_2();
    const theme = useAppSelector(themeSelector);
    const dispatch = useAppDispatch();
    useEffect(() => {
        const changeTheme = (event) => {
            dispatch(updateTheme(event.matches ? 'dark' : 'light'));
        };
        // change according to system
        if (window.matchMedia &&
            window.matchMedia('(prefers-color-scheme: dark)').matches) {
            dispatch(updateTheme('dark'));
        }
        // keep watching
        window
            .matchMedia('(prefers-color-scheme: dark)')
            .addEventListener('change', changeTheme);
        return () => {
            window
                .matchMedia('(prefers-color-scheme: dark)')
                .removeEventListener('change', changeTheme);
        };
    }, [dispatch]);
    useEffect(() => {
        var _a, _b;
        if (theme === 'dark') {
            (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.classList.add('dark');
        }
        else {
            (_b = document.querySelector('body')) === null || _b === void 0 ? void 0 : _b.classList.remove('dark');
        }
    }, [theme]);
};
_react_refresh_temp_2(useThemeSettings, "Yqc8CPrUNkacXz8vciMiWKXRmKs=", false, () => [useAppSelector, useAppDispatch]);
export default useThemeSettings;
